export function sendConsoleTelemetryEvent(event) {
  if (process.env.NODE_ENV === "production") {
    console.info(`[tema-telemetry] ${event.name}`, event);
    return;
  }

  console.info(`[tema-telemetry] ${event.name}`, event);
}
